/*
THIS COMPONENT INCLUDING IN ALL ADMIN PAGES
 ---------------------------------------------*/
class TrackingManager {

    constructor() {
        this.formSelector = '#track_form';
        this.trackInputSelector = '#track_id';
        this.saveTrackButtonSelector = '#save_track';
        this.checkTrackButtonSelector = '#check_track';
        this.changeTrackButtonSelector = '#change_track';
        this.cancelEditingButtonSelector = '#cancel_editing_track';
        this.messageBox = '#track-message';
    }

    getData() {
        return $(this.formSelector).serialize();
    }

    changeTrack() {
        let self = this;
        $.ajax({
            url: '/shop/orders/track/change',
            type: 'POST',
            data: self.getData(),
            success: function (response) {
                self.showResponse(response.message);
            },
            error: function (response) {
                self.errorMessage(response.status, response.responseJSON);
            }
        });
    }

    checkTrack() {
        let self = this;
        $.ajax({
            url: '/shop/orders/track/check',
            type: 'POST',
            data: self.getData(),
            success: function (response) {
                self.showResponse(response.message);
            },
            error: function (response) {
                self.errorMessage(response.message, response.responseJSON);
            }
        });
    }

    showResponse(message, isError = false) {
        let messageBox = $(this.messageBox);
        this.setMessageClass(messageBox, isError);
        messageBox.html(message);
        messageBox.show();
    }

    setMessageClass(messageBox, isError) {
        if (isError) {
            messageBox.removeClass('success-message');
            messageBox.addClass('error-message');
        } else {
            messageBox.removeClass('error-message');
            messageBox.addClass('success-message');
        }
    }

    errorMessage(status, response) {
        let message = status === 422
            ? response.errors.track_id[0]
            : response.message;

        this.showResponse(message, true);
    }

    init() {
        this.listenSaveTrack();
        this.listenCheckTrack();
        this.listenChangeTrack();
        this.listenCancelEditing();
    }

    listenSaveTrack() {
        $(document).on('click', this.saveTrackButtonSelector, () => {
            this.changeTrack();
            this.setStateDefault();
        });
    }

    listenCheckTrack() {
        $(document).on('click', this.checkTrackButtonSelector, (event) => {
            event.stopPropagation();
            this.checkTrack();

            return false;
        });
    }

    listenChangeTrack() {
        $(document).on('click', this.changeTrackButtonSelector, () => {
            this.setStateTrackEditing();
        });
    }

    listenCancelEditing() {
        $(document).on('click', this.cancelEditingButtonSelector, () => {
            this.setStateDefault();
        });
    }

    setStateTrackEditing() {
        $(this.trackInputSelector).attr('readonly', false);
        $(this.checkTrackButtonSelector).hide();
        $(this.changeTrackButtonSelector).hide();
        $(this.saveTrackButtonSelector).show();
        $(this.cancelEditingButtonSelector).show();
    }

    setStateDefault() {
        $(this.trackInputSelector).attr('readonly', true);
        $(this.saveTrackButtonSelector).hide();
        $(this.cancelEditingButtonSelector).hide();
        $(this.checkTrackButtonSelector).show();
        $(this.changeTrackButtonSelector).show();
    }


}

export default TrackingManager;
